import React from 'react'

/**
 * Convierte markup WhatsApp a React elements
 * Soporta: *bold*, _italic_, ~strikethrough~, `code`, ```code block```
 */
export function formatWhatsAppText(text) {
  if (!text) return null

  // 1. Code blocks primero (triple backtick)
  const codeBlockRegex = /```([\s\S]*?)```/g
  const segments = []
  let lastIndex = 0
  let match

  while ((match = codeBlockRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, match.index) })
    }
    segments.push({ type: 'codeblock', value: match[1] })
    lastIndex = match.index + match[0].length
  }
  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) })
  }
  if (segments.length === 0) {
    segments.push({ type: 'text', value: text })
  }

  return segments.map((segment, i) => {
    if (segment.type === 'codeblock') {
      return (
        <pre key={i} className="bg-gray-800 text-green-300 rounded px-3 py-2 my-1 text-xs overflow-x-auto font-mono">
          {segment.value.trim()}
        </pre>
      )
    }
    return <span key={i}>{formatInlineText(segment.value)}</span>
  })
}

/**
 * Procesa formato inline: *bold*, _italic_, ~strike~, `code`
 */
function formatInlineText(text) {
  const inlineRegex = /`([^`]+)`|\*([^*]+)\*|_([^_]+)_|~([^~]+)~/g
  const result = []
  let lastIdx = 0
  let m

  while ((m = inlineRegex.exec(text)) !== null) {
    if (m.index > lastIdx) {
      result.push(text.slice(lastIdx, m.index))
    }

    if (m[1] !== undefined) {
      result.push(
        <code key={m.index} className="bg-gray-200 text-red-600 rounded px-1 py-0.5 text-xs font-mono">
          {m[1]}
        </code>
      )
    } else if (m[2] !== undefined) {
      result.push(<strong key={m.index}>{m[2]}</strong>)
    } else if (m[3] !== undefined) {
      result.push(<em key={m.index}>{m[3]}</em>)
    } else if (m[4] !== undefined) {
      result.push(<del key={m.index}>{m[4]}</del>)
    }

    lastIdx = m.index + m[0].length
  }

  if (lastIdx < text.length) {
    result.push(text.slice(lastIdx))
  }

  return result.length > 0 ? result : text
}
